import {
  BUSINESS_TYPE,
  CASE_TYPE_EXISTING,
  CUSTOMER_UUID,
  BUSINESS_CURRENT_ACCOUNT,
  ACCOUND_DETAILS,
  ADDITIONAL_PRODUCT,
  MANDATE_INFO,
  INITIAL_QUESTIONS_TMSP,
  PRODUCT_NAME,
  SOURCE_ID,
  INITIAL_INFO,
  LINK_CODE_KEY,
  CASE_SUBTYPE_MULTIPARTY
} from '../../utils/constants';
import { INITIAL_QUESTION_PAYLOAD } from '../../routes/initialQuestionsSection/initialQuestionPayload';
import { getCaseSubType } from '../../utils';
import { getDocumentPayload } from './payloadUtils/getDocumentPayload';
import { selectors as contentSelector } from '../../infrastructure/content';
import { getUsername } from '../../infrastructure/cases/selectors';
import { getBlackbox } from '../../utils/deviceRisk';

const BUSINESS_TYPE_FIELD = 'businessTypeField';
const BUSINESS_ID = 'business';
export const createCasePayload = (state, customer, linkcode) => {
  const caseType = getCaseSubType(state);
  const businessType = getBusinessType(caseType, state);
  const customer_uuid = state.config.get(CUSTOMER_UUID);
  let offerType = state.config.get(PRODUCT_NAME);
  offerType = offerType ? decodeURIComponent(offerType) : BUSINESS_CURRENT_ACCOUNT;
  const sourceId = state.config.get(SOURCE_ID);
  const linkCode = linkcode || state.config.get(LINK_CODE_KEY);
  let casePayload = {
    case_subtype: caseType,
    product: {
      type: offerType.toUpperCase(), // Current, Choice
      variant: businessType // optional  Sole Trader/Limited Company
    },
    customer_id: {
      personal: customer_uuid
    },
    applicant: {
      user_details: {
        username: customer.username || ''
      }
    }
  };
  casePayload.product = isSubtypeNeeded(state, businessType)
    ? Object.assign({}, casePayload.product, {
        sub_type: CASE_SUBTYPE_MULTIPARTY
      })
    : casePayload.product;
  casePayload = sourceId ? Object.assign({}, casePayload, { source_id: sourceId }) : casePayload;
  return JSON.stringify(updatePayloadForLinkCode(casePayload, linkCode));
};
const updatePayloadForLinkCode = (payload, linkCode) => {
  const casePayload = payload;
  if (linkCode) {
    delete casePayload.product.variant;
    casePayload.applicant = Object.assign({}, casePayload.applicant, {
      joint_link_code: `${linkCode}`
    });
    casePayload.product = linkCode
      ? Object.assign({}, casePayload.product, {
          type: casePayload.product.type,
          sub_type: CASE_SUBTYPE_MULTIPARTY
        })
      : casePayload.applicant;
  }
  return casePayload;
};

const updateAccountDetails = (state, details) => {
  const accountDetails = state.dataCapture.get(ACCOUND_DETAILS).toJS();
  const request = {
    account_approx_annual_turnover: details
      ? details.annualTurnover
      : accountDetails.annualTurnover,
    account_payment_types: details ? details.paymentOfType : accountDetails.paymentOfType,
    annual_cash_deposits: details ? details.cashDeposit : accountDetails.cashDeposit,
    account_payment_frequency: details ? details.howPaymentMade : accountDetails.howPaymentMade,
    international_payment: details
      ? details.accountDetailsPayment
      : accountDetails.accountDetailsPayment,
    account_payment_sources: details ? details.paymentCameFrom : accountDetails.paymentCameFrom,
    international_payment_countries: {
      send_payments: details ? details.send_payments : getPayments(accountDetails.send_payments),
      receive_payments: details
        ? details.receive_payments
        : getPayments(accountDetails.receive_payments)
    }
  };
  return request;
};
const updateAdditionalDetails = (state, details) => {
  const getSalesLeadsData =
    state.dataCapture.get(ADDITIONAL_PRODUCT) && state.dataCapture.get(ADDITIONAL_PRODUCT).toJS();
  const getBusinessMandateData =
    state.dataCapture.get(MANDATE_INFO) && state.dataCapture.get(MANDATE_INFO).toJS();
  return {
    sales_leads: convertToSalesLeads(getSalesLeadsData),
    business_mandate: details ? details : getBusinessMandateData
  };
};
const convertToSalesLeads = additionalDetails => {
  return additionalDetails && additionalDetails.additionalProductsInterestedField
    ? additionalDetails.additionalProductsInterestedField.map(data => {
        return { product_name: data.replace('?', ''), interested: 'Y' };
      })
    : [];
};
export const updateCasePayload = (state, details, isReview) => {
  const commonData = {};
  commonData.applicant = {};
  const caseData = state.dataCapture.get('caseData');
  const sourceId = caseData.source_id;
  const caseSubtype = caseData.case_subtype.toLowerCase();
  //TODOxCYBG need to remove hard code of this objec once api is stable enough to return
  const product = caseData.product;
  const jointLinkCode = caseData.applicant.joint_link_code;
  caseData.audit_info.documents = getDocumentPayload(isReview);
  caseData.audit_info.eligibility_questions = getEligibilityQuestion(state);
  const auditInfo = caseData.audit_info;
  caseData.customer_id.business = caseData.customer_id.business
    ? caseData.customer_id.business
    : state.config.get(BUSINESS_ID);
  const custId = caseData.customer_id;
  const businessMandate = caseData.business_mandate;
  commonData.source_id = sourceId;
  commonData.case_subtype = caseSubtype;
  commonData.customer_id = Object.assign({}, custId);
  commonData.audit_info = Object.assign({}, auditInfo);
  commonData.product = Object.assign({}, product);
  commonData.sales_leads = getSalesLead(caseData);
  if (businessMandate) {
    commonData.business_mandate = businessMandate;
  }
  commonData.applicant.joint_link_code = jointLinkCode;
  const updateAccountData = updateAccountDetails(state, details);
  commonData.business_account = Object.assign({}, commonData.business_account, updateAccountData);
  commonData.applicant.user_details = getApplicant(state);
  return commonData;
};
const getApplicant = state => {
  const userDetails = {};
  userDetails.username = getUsername(state);
  return userDetails;
};
export const updateAdditonalPayload = (state, details) => {
  const commonData = updateCasePayload(state);
  const updateData = updateAdditionalDetails(state, details);
  commonData.sales_leads = updateData.sales_leads;
  commonData.business_mandate = getMandatePayload(updateData);
  return JSON.stringify(commonData);
};
const getMandatePayload = updateData => {
  return updateData &&
    updateData.business_mandate &&
    Object.values(updateData.business_mandate) &&
    Object.values(updateData.business_mandate).join('') === ''
    ? {}
    : updateData.business_mandate;
};
const getEligibilityQuestion = state => {
  return INITIAL_QUESTION_PAYLOAD.map(question => {
    question.timestamp = state.config.get(INITIAL_QUESTIONS_TMSP);
    return question;
  });
};
export const getBusinessType = (type, state) =>
  type === CASE_TYPE_EXISTING
    ? state.dataCapture.get(INITIAL_INFO).get(BUSINESS_TYPE_FIELD)
    : decodeURIComponent(state.config.get(BUSINESS_TYPE));
const getSalesLead = caseData =>
  caseData.sales_leads && caseData.sales_leads.length > 0
    ? caseData.sales_leads.filter(leads => leads.product_name.trim() !== '')
    : [];
const getPayments = payments =>
  payments
    ? payments.map(payment => {
        const pay = Object.entries(payment);
        return {
          country_of_payment: pay[0][0],
          turnover_percentage: pay[0][1]
        };
      })
    : [];
export const getSubmitBody = state => {
  const subtype = state.dataCapture.get('caseData')
    ? state.dataCapture.get('caseData').case_subtype
    : '';
  const request = {
    case_subtype: subtype,
    device_details: {
      blackbox: getBlackbox()
    }
  };
  return JSON.stringify(request);
};
const isSubtypeNeeded = (state, type) => {
  return (
    type.toLowerCase() ===
      contentSelector.content(state, 'businessTypeLimitedWithMult').toLowerCase() ||
    type.toLowerCase() ===
      contentSelector.content(state, 'businessTypeLimitedPartnership').toLowerCase()
  );
};
